(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
      document.body.classList.toggle('jjn-menu-open', !open);
    });
  }

  document.querySelectorAll('[data-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.filter;
      const section = button.closest('[data-projects]');
      section.querySelectorAll('[data-filter]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
      section.querySelectorAll('[data-project-card]').forEach((card) => {
        card.hidden = filter !== 'all' && card.dataset.category !== filter;
      });
    });
  });

  document.querySelectorAll('[data-before-after]').forEach((slider) => {
    const range = slider.querySelector('[data-before-after-range]');
    if (!range) return;

    const update = () => {
      slider.style.setProperty('--split', `${range.value}%`);
    };

    update();
    range.addEventListener('input', update);
  });

  document.querySelectorAll('.jjn-checkbox-group').forEach((group) => {
    const output = group.querySelector('[data-project-types-output]');
    const options = group.querySelectorAll('[data-project-type]');
    if (!output || options.length === 0) return;

    const update = () => {
      output.value = Array.from(options)
        .filter((option) => option.checked)
        .map((option) => option.value)
        .join(', ');

      if (output.value) {
        output.name = output.dataset.projectTypesName;
      } else {
        output.removeAttribute('name');
      }
    };

    update();
    options.forEach((option) => option.addEventListener('change', update));
    group.closest('form')?.addEventListener('submit', update);
  });
})();
